// @ts-check
import { useEffect, useState } from 'react'
import styles from './Nav.module.css'
import ScrollContainer from '../ScrollContainer/ScrollContainer'
import { Link } from 'react-router-dom'

export default function Nav() {
  const [offset, setOffset] = useState(0)
  useEffect(() => {
    // Read optional global offset if present
    const val = /** @type {any} */ (window).topNavOffset
    setOffset(typeof val === 'number' ? val : 0)
  }, [])
  return (
    <nav className={styles.nav} style={{ top: offset }}>
      <ScrollContainer>
        <Link to="/agencies" className={styles.active}>
          Discover
        </Link>
        <Link to="/agencies/directory-modeling">Modeling & Talent Agencies</Link>
        <Link to="/agencies/directory-artists">Artists Agencies</Link>
        <Link to="/agencies/directory-services">Production & Creative Services</Link>
      </ScrollContainer>
    </nav>
  )
}
